import React from "react";
import Login from "./../../components/Login";

const LoginPage = () => {
  return (
  <div className="container">
    <Login />
  </div>
  );
};

export default LoginPage;